import { UIElementType } from '../types';

const defaultTypeIds: Record<string, string> = {};
function getDefaultTypeId(sourceName: string): string {
  if (!defaultTypeIds[sourceName]) {
    defaultTypeIds[sourceName] = typeof crypto !== 'undefined' && crypto.randomUUID
      ? crypto.randomUUID()
      : `fallback-${sourceName}-${Date.now()}`;
  }
  return defaultTypeIds[sourceName];
}

export const DEFAULT_UI_ELEMENT_TYPES: UIElementType[] = [
  {
    typeId: getDefaultTypeId('message'),
    sourceName: 'message',
    category: 'message',
    displayName: 'Message',
    textBody: '',
    maxCharacterCount: 50,
    styleCornerRadius: [8, 8, 8, 8],
    styleBackgroundColor: '#333333', // theme-exempt: scene content (default UI element style, saved to the asset)
    styleFont: null,
    styleTextSize: 64, // pixels for Unity (e.g. 64)
    styleTextColour: '#FFFFFF', // theme-exempt: scene content (default UI element style, saved to the asset)
    styleBorder: null,
    styleBorderRadius: null,
    styleBorderThickness: 0,
    styleBorderColour: '#FFFFFF', // theme-exempt: scene content (default UI element style, saved to the asset)
    styleAlignment: null,
    styleJustify: 'center',
    orgMemberId: null,
    availability: 'public',
    isActive: true,
    uss: null,
  }
];
